type SnapshotField = { id: string; type: string; default: unknown };

function canonicalValue(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonicalValue);
  if (value !== null && typeof value === "object") {
    return Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b))
      .map(([key, entry]) => [key, canonicalValue(entry)]));
  }
  return value;
}

/** Compare editable values only; membership list order does not change an assignment. */
export function settingsSnapshot(object: Record<string, unknown>, fields: SnapshotField[]): string {
  return JSON.stringify(fields.map((field) => {
    const value = object[field.id] === undefined ? field.default : object[field.id];
    return [field.id, field.type === "ManyToMany" && Array.isArray(value)
      ? [...value].sort((a, b) => Number(a) - Number(b)) : canonicalValue(value)];
  }));
}
